module.exports = __webpack_public_path__ + "img/Mat.c2bf7ea5.webp";